import { TFunction } from 'next-i18next';

export function meterToString(t: TFunction, meter: number) {
	if (meter < 1000) {
		return `${Math.round(meter)} ${t('common:meterShort')}`;
	}

	return `${parseFloat(Number(meter / 1000).toFixed(2))} ${t('common:kilometerShort')}`;
}
